import React from 'react';

const Navbar = ({ searchTerm, onSearchChange, onAdminClick, checkingAuth }) => {
  return (
    <nav className="navbar">
      <div className="navbar-inner">
        <div className="navbar-brand">
          <span className="brand-icon">&#x1F3C0;</span>
          <span className="brand-text">NBA Draft Board</span>
        </div>

        <div className="navbar-search">
          <input
            type="text"
            placeholder="Search prospects..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="search-input"
          />
        </div>

        {!checkingAuth && <button onClick={onAdminClick} className="btn-admin">Admin</button>}
      </div>

      <style>{`
        .navbar {
          background: #1a1a2e;
          border-bottom: 1px solid #2a2a4a;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .navbar-inner {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 12px 20px;
          gap: 16px;
        }
        .navbar-brand { display: flex; align-items: center; gap: 8px; }
        .brand-icon { font-size: 1.5rem; }
        .brand-text { font-size: 1.2rem; font-weight: 700; color: #ffd200; }
        .navbar-search { flex: 1; max-width: 360px; }
        .search-input {
          width: 100%; padding: 8px 16px; border-radius: 20px;
          border: 1px solid #3a3a5a; background: #16162a; color: #e0e0e0;
          font-size: 0.9rem; outline: none; transition: border-color 0.2s;
        }
        .search-input:focus { border-color: #f7971e; }
        .search-input::placeholder { color: #666688; }
        .btn-admin {
          padding: 8px 18px; border-radius: 20px;
          border: 1px solid #f7971e; background: transparent;
          color: #f7971e; font-size: 0.85rem; cursor: pointer; font-weight: 600;
          transition: all 0.2s;
        }
        .btn-admin:hover { background: #f7971e; color: #1a1a2e; }
        @media (max-width: 640px) {
          .navbar-inner { flex-wrap: wrap; }
          .navbar-search { max-width: 100%; order: 3; flex-basis: 100%; }
        }
      `}</style>
    </nav>
  );
};

export default Navbar;
